const initialState = {
    isFetchingGetFirstData: false,
    array: [],

    isFetchingGetSecondData: false,
    arraySecond: [],

    isFetchingPostAllData: false,

    isFetchingPostFirst: false,

    isGetAllData: false,
};



const FamilyLawReducer = (state = initialState, action) => {
    switch (action.type) {

        case "REQUEST_GET_FIRST_DATA":
            return { ...state, isFetchingGetFirstData: true };
        case "SUCCESS_GET_FIRST_DATA":
            return { ...state, array: action.payload.data, isFetchingGetFirstData: false };
        case "ERROR_GET_FIRST_DATA":
            return { ...state, isFetchingGetFirstData: false };


        case "REQUEST_GET_SECOND_DATA":
            return { ...state, isFetchingGetSecondData: true };
        case "SUCCESS_GET_SECOND_DATA":
            return { ...state, arraySecond: action.payload.data, isFetchingGetSecondData: false };
        case "ERROR_GET_SECOND_DATA":
            return { ...state, isFetchingGetSecondData: false };


        case "REQUEST_POST_ALL_DATA":
            return { ...state, isFetchingPostAllData: true };
        case "SUCCESS_POST_ALL_DATA":
            return { ...state, isFetchingPostAllData: false };
        case "ERROR_POST_ALL_DATA":
            return { ...state, isFetchingPostAllData: false };


        case "REQUEST_POST_FIRST":
            return { ...state, isFetchingPostFirst: true };
        case "SUCCESS_POST_FIRST":
            return { ...state, isFetchingPostFirst: false };
        case "ERROR_POST_FIRST":
            return { ...state, isFetchingPostFirst: false };


        case "REQUEST_GET_ALL_DATA":
            return { ...state, isFetchingGetFirstData: false,
                array: [],
            
                isFetchingGetSecondData: false,
                arraySecond: [],
            
                isFetchingPostAllData: false,
            
                isFetchingPostFirst: false,
            
                isGetAllData: true};
        case "SUCCESS_GET_ALL_DATA":
            return { ...state,
                array:action.payload.data.array,
                arraySecond:action.payload.data.arraySecond,
                 isGetAllData: false };
        case "ERROR_GET_ALL_DATA":
            return { ...state, isGetAllData: false };


        default:
            return state;
    }
}

export default FamilyLawReducer